import { render } from "./SelectLanguage.vue?vue&type=template&id=2158f0e0"
import script from "./SelectLanguage.vue?vue&type=script&lang=js"
export * from "./SelectLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rizome.dvit.cloud/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__